import { Typography } from '@material-ui/core';
import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { modalsActionsClose } from 'store/modules/ModalsActions';
import { ModalsActionsClose } from '../../../../store/modules/ModalsActionTypes';
import { IModalProps } from '../../../../store/modules/ModalsReducer';
import GenericModal, { IGenericModalProps } from '../GenericModal/GenericModal';
import { useStyles } from './styles';

export interface IAlertModalGenericProps extends IGenericModalProps {
  contentText: string;
  title: string;
  key: string;
}

export interface IAlertModal extends IModalProps {
  genericProps: IAlertModalGenericProps;
  modalsActionsClose: (key: string) => ModalsActionsClose;
}

const mapDispatchToProps = (dispatch: Dispatch<any>) =>
  bindActionCreators(
    {
      modalsActionsClose,
    },
    dispatch
  );

const AssembleiaDocsModal = ({ genericProps, open }: IAlertModal) => {
  const classes = useStyles();
  const dispatchAction = useDispatch();

  const toClose = (): void => {
    if (genericProps && genericProps.key) {
      dispatchAction(modalsActionsClose(genericProps.key));
    }
  };

  return (
    <GenericModal
      open={open ?? false}
      title={genericProps.title}
      content={
        <Typography className={classes.content}>
          {genericProps.contentText}
        </Typography>
      }
      genericProps={{
        maxWidth: 'xs',
        onClose: toClose,
        DialogContentProps: {
          className: classes.root,
        },
      }}
    />
  );
};

export default connect(null, mapDispatchToProps)(AssembleiaDocsModal);
